
var scheme = function (btn) {
    btn.onclick = function(){
        if(document.body.className.indexOf(' main-reverseScheme') == -1) document.body.className = document.body.className + ' main-reverseScheme';
        else document.body.className = document.body.className.replace(' main-reverseScheme', '');
        return false;
    }

};

export {scheme};